"use client";

import { useState } from "react";
import dynamic from "next/dynamic";

const MarkdownRenderer = dynamic(() => import("@/components/blog/MarkdownRenderer"), {
  ssr: false,
  loading: () => (
    <div className="animate-pulse bg-muted/20 h-full w-full rounded-xl" />
  ),
});

const SAMPLE = `# Heading

Write **Markdown** on the left, see it rendered on the right.

- Bullet one
- Bullet two

\`\`\`js
console.log("hello world");
\`\`\`
`;

export default function MarkdownPreviewerClient() {
  const [content, setContent] = useState(SAMPLE);

  return (
    <div className="grid md:grid-cols-2 gap-4 pb-10">
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground">Markdown</label>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          spellCheck={false}
          className="w-full h-[32rem] font-mono text-sm p-4 rounded-xl border bg-background resize-y focus:outline-none focus:ring-2 focus:ring-primary/40"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground">Preview</label>
        <div className="w-full h-[32rem] overflow-y-auto rounded-xl border bg-muted/30 p-4 prose prose-neutral dark:prose-invert max-w-none">
          <MarkdownRenderer content={content} />
        </div>
      </div>
    </div>
  );
}
